module.exports = "/_next/static/images/ribbon-duotone-5c73d31033cedd1292e97b4ab55897ee.svg";